import React from 'react';
import './index.css';
import BrandAnalysisTable from "../ThirdPage/BrandAnalysisTable";
// import PlatformAnalysisTable from "../ThirdPage/PlatformAnalysisTable";
// import BarChart from "./BarChart";
import TestPurchaseTable from './TestPurchaseTable';
import TestPie from './TestPie';

import {
    Flex,
    Heading,
    Text,
    SimpleGrid,
    useColorModeValue,
} from "@chakra-ui/react";
import { column } from 'stylis';

const FourthPage = (props) => {
    const {test}=props

    const textColor = useColorModeValue("secondaryGray.900", "white");

    return (
        <div className="fourth-page" style={{marginTop:'50px'}}>
            <Heading  mb='10px'>
                <Flex paddingBottom='10px' justify='space-between' align='center'>
                    <Text
                        color={textColor}
                        lineHeight='100%'
                        m='auto'
                        className="heading1"
                    >
                        TEST PURCHASE
                    </Text>
                </Flex>
            </Heading>
            <Flex px='10px' paddingBottom='40px' justify='space-between' align='center'>
                <Text
                    color={textColor}
                    lineHeight='100%'
                    m='auto'
                    
                    className="heading2"
                >
                    Genuine v/s Counterfeit
                </Text>
            </Flex>
            <Flex paddingInline={100} paddingBottom={100} justify="center" align="center"   >
                
                <TestPurchaseTable finalData={test} heading="Brands" />
            </Flex>
            <Flex px='10px' paddingBottom='40px' justify='space-between' align='center'>
                <Text
                    color={textColor}
                    lineHeight='100%'
                    m='auto'
                    
                    className="heading2"
                >
                    Sellers
                </Text>
            </Flex>
            <Flex paddingInline={100} justify="center" align="center"  >
                
                <TestPurchaseTable finalData={test} heading="Sellers" />
            </Flex>
                


           
        </div>
    );
};

export default FourthPage;
